// Default breakpoint at which the right rail collapses. Below it, the 300x250
// desktop ad slot is not visible, so we serve the mobile unit instead.
// See CBUPT-51359.
export const MOBILE_AD_BREAKPOINT = 1100;

// True when the viewport is narrow enough that the mobile ad unit should be
// served. Width-only — user-agent isn't consulted, since the ticket is about
// layout viewability, not device class. Pass a custom breakpoint when the page's
// right rail collapses at a different width than the default.
export default function shouldUseMobileAd(breakpoint = MOBILE_AD_BREAKPOINT) {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.innerWidth < breakpoint;
}
